import { render, staticRenderFns } from "./MemoDetail.vue?vue&type=template&id=0e22a965&scoped=true&"
import script from "./MemoDetail.vue?vue&type=script&lang=ts&"
export * from "./MemoDetail.vue?vue&type=script&lang=ts&"
import style0 from "./MemoDetail.vue?vue&type=style&index=0&id=0e22a965&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e22a965",
  null
  
)

export default component.exports